import React, { memo, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {getprojectandmetadata, getToken} from '../Utils/Common';
import StundenKostenschaetzung from '../Components/Stunden/StundenKostenschaetzung';
import Freigabe from '../Components/Stunden/Freigabe';
import Zeit from '../Components/Stunden/Zeit';
import moment from 'moment';
import StundenAuftraggeber from '../Components/Stunden/StundenAuftraggeber';
import StundenMaterial from '../Components/Stunden/StundenMaterial';
import StundenGeraete from '../Components/Stunden/StundenGeraete';
import StundenActionButtonsComponent from '../Components/Stunden/StundenActionButtonsComponent';
import StundenReportEmployeeTable from '../Components/Stunden/StundenReportEmployeeTable';
import { Checkbox } from '@material-ui/core';

import Bulb from 'react-bulb';
import WorkDone from '../Components/Stunden/WorkDone';
import TaetigkeitVerortung from '../Components/TaetigkeitVerortung';

function StundenPage({ history }) {
    let [rDate, setRDate] = useState(null);
    let [cDate, setCDate] = useState(null);
    let [tValue, setTValue] = useState('');

    let [donerDate, setDoneRDate] = useState(null)
    let [donecDate, setDoneCDate] = useState(null)
    let [donetValue, setDoneTValue] = useState("")

    let dataID = history.location.state.dataID
    const [repeatStatus, setRepeatStatus] = useState(false)
    const [stundenReportData, setStundenReportData] = useState({})
    const [originState, setOriginState] = useState(false);
    const [completeData, setCompleteData] = useState({})
    const [abmeldungState, setAbmeldungState] = useState(false)

    const [stundenTitle, setStundenTitle] = useState("")
    const [creatorFirstName, setCreatorFirstName] = useState("")
    const [creatorLastName, setCreatorLastName] = useState("")
    const [creationDate, setCreationDate] = useState("")
    const [materialData, setMaterialData] = useState([])
    const [projectData, setProjectData] = useState({})
    let [metadata, setMetaData] = useState({})

    //const [revTD, setRevTD] = useState({})

    const [pID, setPID] = useState(sessionStorage.getItem('projectID'));

    const [isChange, setIsChange] = useState(false);
    let type = history.location.state.type;
    let [status, setstatus] = useState(history.location.state.status);
    let date = history.location.state.date;

    useEffect(() => {

        let apiBody = {
            token: getToken(),
            data: {
                stundenlohnID: dataID,
                type: type
            }
        };

        async function getStundenReportData() {
            let response = await fetch(process.env.REACT_APP_BACKEND_API_URI + 'mobileappbackend/get_stundenlohn', {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(apiBody)
            });

            let data = await response.json();
            console.log(data, 444666);

            setCompleteData(data)
            let dataToShow = []
            if (type === "Stunden-Anmeldung")
            {
                dataToShow = data.stundenlohnanmeldung
                setOriginState(false)
                if (dataToShow.auftraggeber_confirmation.length === 0)
                {
                    setRDate(null)
                    setCDate(null)
                    setTValue("")
                }
            else if (dataToShow.auftraggeber_confirmation.length >> 0)
                {
                    if (!("registerDate" in dataToShow.auftraggeber_confirmation[0])) {
                        setRDate(null)
                    } else {
                        setRDate(dataToShow.auftraggeber_confirmation[0].registerDate)
                    }

                    if (!("confirmationDate" in dataToShow.auftraggeber_confirmation[0])) {
                        setRDate(null)
                    } else {
                        setCDate(dataToShow.auftraggeber_confirmation[0].confirmationDate)
                    }

                    if (!("confirmationType" in dataToShow.auftraggeber_confirmation[0])) {
                        setTValue("")
                    } else {
                        setTValue(dataToShow.auftraggeber_confirmation[0].confirmationType)
                    }

                    if ( dataToShow.auftraggeber_confirmation[0].firstName===""
                    && dataToShow.auftraggeber_confirmation[0].lastName==="") {
                        dataToShow.auftraggeber_confirmation=[]
                    }

                    //setCDate(dataToShow.auftraggeber_confirmation[0].confirmationDate)
                    //setTValue(dataToShow.auftraggeber_confirmation[0].confirmationType)
                }
                setMaterialData(dataToShow.material_angemeldet)
            }
            else if (type === "Stunden-Abmeldung")
            {
                setOriginState(true)
                dataToShow = data.stundenlohnabmeldung
                if (dataToShow.auftraggeber_done === undefined
                    || dataToShow.auftraggeber_done === {}
                    || Object.values(dataToShow.auftraggeber_done).every(x => x === '')
                ) {
                    dataToShow.auftraggeber_done.length = 0
                    setDoneRDate(null)
                    setDoneCDate(null)
                    setDoneTValue("")
                }
                else if (dataToShow.auftraggeber_done)
                {
                    let g = JSON.parse(JSON.stringify(dataToShow.auftraggeber_done))
                    if(g.firstName==="" & g.lastName==="" & g.role==="") {
                        dataToShow.auftraggeber_done = [];
                    }
                else{
                    dataToShow.auftraggeber_done = [
                        {
                            firstName: g.firstName,
                            lastName: g.lastName,
                            role: g.role,
                            entscheidungsbefugnis: g.entscheidungsbefugnis,
                            email:g.email
                        }
                        ];
                    }
                    setDoneRDate(g.doneDate)
                    setDoneCDate(g.confirmationDate)
                    setDoneTValue(g.confirmationType)

                       /* {
                            firstName: g.firstName,
                            lastName: g.lastName,
                            role: g.role,
                            entscheidungsbefugnis: g.entscheidungsbefugnis,
                            doneDate: g.doneDate,
                            confirmationDate: g.confirmationDate,
                            confirmationType: g.confirmationType
                        }*/

                }

              /*  if (dataToShow.auftraggeber_done.length === 0) {
                    setDoneRDate(null)
                    setDoneCDate(null)
                    setDoneTValue("")
                } else if (dataToShow.auftraggeber_done.length >> 0)
                {
                    if (!("doneDate" in dataToShow.auftraggeber_done[0])) {
                        setDoneRDate(null)
                    } else {
                        setDoneRDate(dataToShow.auftraggeber_done[0].doneDate)
                    }

                    if (!("confirmationDate" in dataToShow.auftraggeber_done[0])) {
                        setDoneCDate(null)
                    } else {
                        setDoneCDate(dataToShow.auftraggeber_done[0].confirmationDate)
                    }

                    if (!("confirmationType" in dataToShow.auftraggeber_done[0])) {
                        setDoneTValue("")
                    } else {
                        setDoneTValue(dataToShow.auftraggeber_done[0].confirmationType)
                    }

                    //setCDate(dataToShow.auftraggeber_confirmation[0].confirmationDate)
                    //setTValue(dataToShow.auftraggeber_confirmation[0].confirmationType)
                }*/

                /*if (dataToShow.auftraggeber_done === undefined) {
                    setDoneRDate(null)
                    setDoneCDate(null)
                    setDoneTValue("")
                } else if (dataToShow.auftraggeber_done)
                {
                    if(!("doneDate" in dataToShow.auftraggeber_done)){
                        setRDate(null)
                    }else{setRDate(dataToShow.auftraggeber_done.doneDate)}

                    if(!("confirmationDate" in dataToShow.auftraggeber_done)){
                        setRDate(null)
                    }else{setCDate(dataToShow.auftraggeber_done.confirmationDate)}

                    if(!("confirmationType" in dataToShow.auftraggeber_done)){
                        setTValue("")
                    }else{setTValue(dataToShow.auftraggeber_done.confirmationType)}

                    //setCDate(dataToShow.auftraggeber_confirmation[0].confirmationDate)
                    //setTValue(dataToShow.auftraggeber_confirmation[0].confirmationType)
                }*/


                setMaterialData(dataToShow.material_abgemeldet)
                setAbmeldungState(true)
            }
            setStundenReportData(dataToShow);
            setPID(dataToShow.projectID);
            setStundenTitle(dataToShow.stundenlohnTitle);
            setCreatorFirstName(
                dataToShow.auftraggeber_registeration && dataToShow.auftraggeber_registeration[0]
                    ? dataToShow.auftraggeber_registeration[0].firstName
                    : 'NA'
            );
            setCreatorLastName(
                dataToShow.auftraggeber_registeration && dataToShow.auftraggeber_registeration[0]
                    ? dataToShow.auftraggeber_registeration[0].lastName
                    : 'NA'
            );
            setCreationDate(
                dataToShow.creationDate
                    ? moment(dataToShow.creationDate, 'YYYY-MM-DDTHH:mm:ss.SSS').format('DD-MM-YYYY')
                    : moment().format('DD-MM-YYYY')
            );
            setRepeatStatus(dataToShow.repeat_status);

            //get meta and project
            apiBody = {
                token: getToken(),
                data: {
                    dataID: dataID
                }
            };
            let res = await getprojectandmetadata(apiBody)
            /*let res = await fetch(process.env.REACT_APP_BACKEND_API_URI + 'mobileappbackend/get_onemetaandproject', {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(apiBody)
            })
                .then((response) => response.json())
                .catch((error) => {
                    console.error('Error:', error);
                });*/
            console.log(res, 'projandmetadata');
            setProjectData(res.proj_data);
            setMetaData(res.meta_data);
        }
        getStundenReportData().then((r) => r);
    }, []);

    useEffect(() => {
        console.log(stundenReportData);
    }, [stundenReportData]);

    return (
        <div
            style={{
                width: '100%'
            }}
            className="handwai-dark"
        >
            <div
                style={{
                    padding: 40,
                    width: '100%'
                    // backgroundColor:'red',
                }}
            >
                <Row>
                    <Col sm={8}>
                        {type.includes('An') && (
                            <label style={{ fontSize: 40 }} className="handwai-text-label-main add-bottom-0-margin">
                                {'Stundenlohn - Anmeldung: ' + stundenTitle}
                            </label>
                        )}
                        {type.includes('Ab') && (
                            <label style={{ fontSize: 30 }} className="handwai-text-label-main add-bottom-0-margin">
                                {'Stundenlohn - Ausführung: ' + stundenTitle}
                            </label>
                        )}
                        <br />
                        <label className="handwai-text-label-normal add-bottom-0-margin">
                            {'Ersteller: ' +
                                creatorFirstName +
                                ' ' +
                                creatorLastName +
                                ', ' +
                                'Erstellungsdatum: ' +
                                creationDate}
                        </label>
                    </Col>
                    <Col sm={7}></Col>
                    <Col />
                </Row>
                <br />
                <Row>
                    <Col sm={6}></Col> <Col />
                    <Col sm={5} />
                </Row>
                <Row>
                    <Col sm={6}></Col> <Col />
                    <Col sm={5} />
                </Row>
                <Row>
                    {/*<Col style={{paddingRight:0}}/>*/}
                    {abmeldungState && (
                        <>
                            <Col sm={5} md={5} lg={5}>
                                <StundenReportEmployeeTable
                                    setIsChange={setIsChange}
                                    originState={originState}
                                    tEmployeeData={stundenReportData.coworkers}
                                    defaultStartTime={null}
                                    defaultEndTime={null}
                                    stundenReportData={stundenReportData}
                                    setStundenReportData={setStundenReportData}
                                />
                            </Col>
                            {stundenReportData.workDone && (
                                <Col sm={3}>
                                    <label
                                        style={{ fontSize: 40, color: 'green' }}
                                        className="handwai-text-label-main add-bottom-0-margin"
                                    >
                                        Abgeschlossen
                                    </label>
                                </Col>
                            )}
                            {!stundenReportData.workDone && (
                                <Col sm={3}>
                                    <label
                                        style={{ fontSize: 40, color: 'red' }}
                                        className="handwai-text-label-main add-bottom-0-margin"
                                    >
                                        Nicht Abgeschlossen
                                    </label>
                                </Col>
                            )}

                            <Col sm={0.5}>
                                <Bulb size={30} color={stundenReportData.workDone === true ? 'green' : 'red'} />
                            </Col>
                        </>
                    )}

                    {!abmeldungState && (
                        <Col sm={12}>
                            <Zeit
                                disableStatus={status==="Akzeptiert"}
                                originState={originState}
                                setIsChange={setIsChange}
                                estimatableTime={
                                    stundenReportData.estimation ? stundenReportData.estimation.estimatableTime : ''
                                }
                                meister={stundenReportData.estimation ? stundenReportData.estimation.roles.meister : ''}
                                monteur={
                                    stundenReportData.estimation
                                        ? stundenReportData.estimation.roles.bauleitender_monteur
                                        : ''
                                }
                                geselle={stundenReportData.estimation ? stundenReportData.estimation.roles.geselle : ''}
                                lehrling={
                                    stundenReportData.estimation ? stundenReportData.estimation.roles.lehrling : ''
                                }
                                helfer={stundenReportData.estimation ? stundenReportData.estimation.roles.helfer : ''}
                                //helfer={stundenReportData?.estimation[0].roles.Meister}
                                coworkers={[]}
                                stundenReportData={stundenReportData}
                                setStundenReportData={setStundenReportData}
                                //totalDuration={parseFloat(stundenReportData?.aufwand?.meister) + parseFloat(stundenReportData?.aufwand?.monteur) + parseFloat(stundenReportData?.aufwand?.geselle) + parseFloat(stundenReportData?.aufwand?.lehring) + parseFloat(stundenReportData?.aufwand?.helfer)}
                                totalDuration={
                                    stundenReportData.estimation ? stundenReportData.estimation.totalduration : ''
                                }
                            />
                        </Col>
                    )}
                </Row>
                <Row>
                    <Col sm={12}>
                        <StundenAuftraggeber
                            pID={pID}
                            setIsChange={setIsChange}
                            auftraggeberData={stundenReportData?.auftraggeber_registeration}
                        />
                    </Col>
                </Row>
                <br />
                <br />
                <br />
                <Row>
                    <Col sm={4}>
                        <label className="handwai-text-label-main">{'Tätigkeit'}</label>
                    </Col>
                    <Col sm={7}></Col>
                    <Col />
                </Row>
                <br />
                <div
                    className="tatigkeiten-div-scroll"
                    style={{
                        width: '100%',
                        height:'50vh',
                        // backgroundColor: 'red',
                        display: 'flex',
                        // padding: 20
                    }}
                >
                    <TaetigkeitVerortung
                        setIsChange={setIsChange}
                        setStundenReportData={setStundenReportData}
                        originState={originState}
                        stundenReportData={stundenReportData}
                        type={type}
                    />
                    {/* {multipletatigkeitimages()} */}
                </div>
                <br /> <br />
                <Row>
                    <Col sm={7}>
                        <StundenMaterial
                            disableStatus={status==="Akzeptiert"}
                            setIsChange={setIsChange}
                            originState={originState}
                            stundenReportData={stundenReportData}
                            setStundenReportData={setStundenReportData}
                            materialData={materialData}
                            type={type}
                        />
                    </Col>
                    {/*<Col sm={4}>
                        <Geraete
                            setIsChange={setIsChange}
                            originState={originState}
                            geraeteData={stundenReportData?.material_geraet}/>
                    </Col>*/}
                    <Col sm={4}>
                        <StundenGeraete
                            disableStatus={status==="Akzeptiert"}
                            setIsChange={setIsChange}
                            originState={originState}
                            stundenReportData={stundenReportData}
                            setStundenReportData={setStundenReportData}
                            geraeteData={stundenReportData?.material_geraet}
                        />
                    </Col>
                    <Col />
                </Row>
                <br /> <br />
                {!abmeldungState && (
                    <>
                        <StundenKostenschaetzung
                            disableStatus={status==="Akzeptiert"}
                            originState={originState}
                            setIsChange={setIsChange}
                            stundenReportData={stundenReportData}
                            setStundenReportData={setStundenReportData}
                            kosten={stundenReportData.cost_estimation}
                        />
                        <br /> <br />
                        <Row>
                            <Col sm={11}>
                                <Freigabe
                                    disableStatus={status==="Akzeptiert"}
                                    setRDate={setRDate}
                                    setCDate={setCDate}
                                    rDate={rDate}
                                    cDate={cDate}
                                    setIsChange={setIsChange}
                                    pID={pID}
                                    originState={originState}
                                    registerationdata={stundenReportData?.auftraggeber_registeration}
                                    auftraggeberData={stundenReportData?.auftraggeber_confirmation}
                                    stundenReportData={stundenReportData}
                                    setStundenReportData={setStundenReportData}
                                    tValue={tValue}
                                    setTValue={setTValue}
                                />
                            </Col>
                        </Row>
                    </>
                )}
                {abmeldungState && (
                    <Row>
                        <Col sm={11}>
                            <WorkDone
                                setDoneRDate={setDoneRDate}
                                setDoneCDate={setDoneCDate}
                                donerDate={donerDate}
                                donecDate={donecDate}
                                setIsChange={setIsChange}
                                pID={pID}
                                originState={false}
                                registerationdata={stundenReportData?.auftraggeber_registeration}
                                auftraggeberData={stundenReportData?.auftraggeber_done}
                                stundenReportData={stundenReportData}
                                setStundenReportData={setStundenReportData}
                                donetValue={donetValue}
                                setDoneTValue={setDoneTValue}
                            />
                        </Col>
                    </Row>
                )}
                <br />
                <br />
                {abmeldungState && (
                    <Row>
                        <Col
                            sm={1}
                            style={{
                                marginRight: -100
                            }}
                        >
                            <div>
                                <Checkbox
                                    style={{
                                        backgroundColor: 'white',
                                        width: '30%'
                                    }}
                                    color="grey"
                                    defaultChecked={repeatStatus}
                                    key={Math.random()}
                                    onChange={(e) => {
                                        let newState = stundenReportData;
                                        newState.repeat_status = e.target.checked;
                                        setStundenReportData(newState);
                                        console.log(newState, 4321);
                                    }}
                                />
                            </div>
                        </Col>
                        <Col sm={1} style={{ textAlign: 'Center', verticalAlign: 'Center' }}>
                            <label className="handwai-text-label-normal add-bottom-0-margin">
                                {/*{"Teilabmeldung:Anmeldung wird nicht gelöscht"}*/}
                                {'Abmeldung Beenden'}
                            </label>
                        </Col>
                    </Row>
                )}

            </div>
            <br />
            <br />
            <div className="horizontal-line"></div>

            <div style={{ width: '100%' }}>
                <StundenActionButtonsComponent
                    disableStatus={status==="Akzeptiert"}
                    setDoneRDate={setDoneRDate}
                    setDoneCDate={setDoneCDate}
                    setDoneTValue={setDoneTValue}
                    setRDate={setRDate}
                    setCDate={setCDate}
                    setTValue={setTValue}
                    donerDate={donerDate}
                    donecDate={donecDate}
                    donetValue={donetValue}
                    date={date}
                    rDate={rDate}
                    cDate={cDate}
                    tValue={tValue}
                    setstatus={setstatus}
                    status={status}
                    isChange={isChange}
                    creatorFirstName={creatorFirstName}
                    creatorLastName={creatorLastName}
                    dataID={dataID}
                    type={type}
                    setIsChange={setIsChange}
                    originState={originState}
                    stundenReportData={stundenReportData}
                    setStundenReportData={setStundenReportData}
                    completeData={completeData}
                    projectData={projectData}
                    metadata={metadata}
                />
            </div>

            <br />
            <br />
        </div>
    );
}

export default memo(StundenPage);
